import { useGet } from '../../HttpClient';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

export function useAccountByAccountNumber(accountNumber: string) {
  const get = useGet(true, "ams");
  const getAccountByAccountNumber = (accountNumber: string) => {
    return get<{ accountId: string }>(`/api/proxy/ams/account-service/account/number/${accountNumber}`);
  };
  return useQueryWithErrorHandling({
    queryKey: ['accountByAccountNumber', accountNumber],
    queryFn: async () => await getAccountByAccountNumber(accountNumber),
    enabled: !!accountNumber,
  });
}
